import React, {Component, useEffect} from "react";
import Section from "./layouts/Section";
import { userSelect, allRemoteSettingsSelect } from '../redux/selectors/index';
import { useSelector, useDispatch } from 'react-redux';
import {WebLink, SiteWide} from "./customComponents";

function Faq(){

    const bakground = require('../images/space.jpg');

    const site_settings = useSelector(allRemoteSettingsSelect);

    return (
        <SiteWide ackgroundImage={bakground} title={`System broadcast`}>
            <Section  title={'Broadcast'}>
                <div className="container-inner mg-top-30">
                    <div className="container-fluid">
                        <div className="row flex-row">

                        
                            <div className="col-xl-12">
                                {/* Basic Tabs */}

                                {site_settings?.faq?.map((item, index) => (
                                <div className="widget has-shadow" style={{backgroundColor: 'rgba(0, 0, 0, 0.8)'}}>
                                    <div style={{border: 0, backgroundColor: 'rgba(0, 0, 0, 0.8) !important'}} className="bg-info widget-header bordered no-actions d-flex align-items-center">
                                        <h6 className="text-white">{item?.question}</h6>
                                    </div>
                                    <div className="widget-body sliding-tabs">
                                        
                                        <div className="tab-content pt-3">
                                            <div className="text-white tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="base-tab-1">
                                                {item?.answer}
                                            </div>
                                        </div>
                                    </div>

                                </div>)
                                )}
                            </div>

                        </div>
                        {/* End Row */}
                    </div>
                </div>
            </Section>
        </SiteWide>
    );

}

export default Faq;